import React from 'react';
import { Alert, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import CommonTable from '../../../common/components/CommonTable';
import InvoiceTableRow from './InvoiceTableRow';

function InvoiceTable({ data, offset, changeOffset }) {
  if (data?.items.length === 0) {
    return (
      <div className="alert-wrapper">
        <Alert color="info" className="mb-0">
          There is currently no data to show.
        </Alert>
      </div>
    );
  }

  return (
    <Col xs="12">
      <CommonTable
        className="settings-table settings-table--invoices"
        headerOptions={[
          'Date',
          'Invoice Number',
          'Payment Method',
          'Price',
          'Status',
          'Actions',
        ]}
        lastIsActionColumn={true}
        rowComponent={InvoiceTableRow}
        data={data}
        offset={offset}
        onOffsetChange={changeOffset}
        pagination={true}
      />
    </Col>
  );
}

InvoiceTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
};

export default InvoiceTable;
